// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"FormCheck_horizontal__2_d14","item":"FormCheck_item__IEK-O","load":"FormCheck_load__3XkIc"};